import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
/* eslint-disable no-nested-ternary */
import React from 'react';
import { AwesomeButtonProgress } from 'react-awesome-button';
import { Form, Input, Message, Transition } from 'semantic-ui-react';
import { log, setLocalStorageWithExpiry } from '@emyw/core-lib';
import { validatePromotionCode } from '../utils';
// import 'react-awesome-button/src/styles/styles.scss';
import 'react-awesome-button/dist/styles.css';
var FREE_PLAN_NOTE = '\n\nA portion of proceeds will support your organization\nif you upgrade to a paid plan in the future.';
var INVALID_CODE = 'That code wasn\'t found. \nPerhaps you could try another one.';
var PromotionCode = /*#__PURE__*/function (_React$Component) {
  _inherits(PromotionCode, _React$Component);
  var _super = _createSuper(PromotionCode);
  function PromotionCode(props, _context) {
    var _this;
    _classCallCheck(this, PromotionCode);
    _this = _super.call(this, props, _context);
    _this.managingAccountPage = function () {
      return window.location.pathname.indexOf('manageaccount') > -1;
    };
    _this.checkCode = function () {
      var _this$props = _this.props,
        defaultPromoCode = _this$props.defaultPromoCode,
        user = _this$props.user,
        onValidatedPromoCode = _this$props.onValidatedPromoCode;
      // check if this promo code is valid
      // log.trace('checking code');
      if (defaultPromoCode) {
        validatePromotionCode(defaultPromoCode, false, user, _this.managingAccountPage()).then(function (res) {
          if (!res.ok) {
            _this.setState({
              activationMessage: null,
              status: 'invalid',
              invalidCodeMessage: res.errors[0].message
            });
          } else {
            onValidatedPromoCode(res);
            var activationMessage = res.activationMessage,
              activationMessageManageAccount = res.activationMessageManageAccount;
            _this.setState({
              status: 'locked',
              activationMessage: _this.managingAccountPage() ? activationMessageManageAccount : activationMessage,
              invalidCodeMessage: null
            });
          }
        });
      }
    };
    _this.handleSubmit = function (element, next) {
      var _this$props2 = _this.props,
        user = _this$props2.user,
        activateOnValidCode = _this$props2.activateOnValidCode,
        onValidatedPromoCode = _this$props2.onValidatedPromoCode,
        onInvalidPromoCode = _this$props2.onInvalidPromoCode,
        onCodeRemoved = _this$props2.onCodeRemoved,
        loadUser = _this$props2.loadUser,
        context = _this$props2.context;
      var status = _this.state.status;
      if (!['waiting', 'invalid'].includes(status)) {
        if (status === 'locked') {
          log.trace('removing code');
          // remove the promo code
          localStorage.removeItem('enjoy-promo-code');
          _this.setState({
            status: 'waiting'
          });
          setTimeout(function () {
            _this.setState({
              invalidCodeMessage: 'The code has been removed'
            });
            if (document.getElementById('verificationCode')) document.getElementById('verificationCode').value = '';
            next();
          }, 1000);
          setTimeout(function () {
            _this.setState({
              invalidCodeMessage: null
            });
          }, 4000);
          onCodeRemoved();
          // next();
        }

        return;
      }
      _this.setState({
        status: 'validating'
      });
      log.trace(user);
      var promoCode = (document.getElementById('verificationCode') || {}).value;
      validatePromotionCode(promoCode, activateOnValidCode, user, _this.managingAccountPage()).then(function (res) {
        setTimeout(function () {
          next();
          log.trace(res);
          if (res.ok) {
            onValidatedPromoCode(res);
            var activationMessage = res.activationMessage,
              activationMessageManageAccount = res.activationMessageManageAccount;
            _this.setState({
              status: 'validated',
              activationMessage: _this.managingAccountPage() ? activationMessageManageAccount : activationMessage,
              invalidCodeMessage: null
            });
            setTimeout(function () {
              return _this.setState({
                status: 'locked'
              });
            }, 3000);
            if (loadUser) {
              loadUser('network-only')(function (_ref) {
                var newUser = _ref.user;
                context.setAppState({
                  user: newUser
                });
              });
            }
          } else {
            var error = res.errors[0].message;
            // CSM - to hack the system to let the promo code entered during signup,
            // check the error message for a specific response and then proceed in that case
            // if (!this.managingAccountPage() && error.indexOf('currently subscribed through N\\A.') > -1) {
            //     this.setState({
            //         status: 'validated',
            //         activationMessage: "Promo code accepted. You're all set!",
            //         invalidCodeMessage: null,
            //     });
            //     setLocalStorageWithExpiry('enjoy-promo-code', promoCode, 604800000);
            //     setTimeout(() => this.setState({ status: 'locked' }), 3000);
            // } else {
            if (onInvalidPromoCode) onInvalidPromoCode({
              error: error
            });
            _this.setState({
              status: 'invalid',
              invalidCodeMessage: error !== 'Invalid code' ? error : INVALID_CODE
            });
            setTimeout(function () {
              _this.setState({
                status: 'waiting'
              });
              // if (document.getElementById('verificationCode')) document.getElementById('verificationCode').value = '';
            }, 3000);
            // setTimeout(() => this.setState({ invalidCodeMessage: null }), 7500);
            // }
          }
        }, 1000);
      }).catch(function (error) {
        next();
        if (onInvalidPromoCode) onInvalidPromoCode({
          error: error.message
        });
        _this.setState({
          status: 'waiting'
        });
      });
    };
    var getInitialActivationMessage = function getInitialActivationMessage() {
      var message = localStorage.getItem('promo-code-activation-message');
      if (!message) message = props.defaultPromoCode ? (props.user || {}).promotionCodeDescription : null;
      return message;
    };
    _this.state = {
      status: 'waiting',
      activationMessage: getInitialActivationMessage(),
      invalidCodeMessage: null
    };
    return _this;
  }
  _createClass(PromotionCode, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkCode();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
        defaultPromoCode = _this$props3.defaultPromoCode,
        user = _this$props3.user;
      // log.trace('Promo code componentDidUpdate', defaultPromoCode, user, prevProps.user);
      if (prevProps.defaultPromoCode !== defaultPromoCode || (prevProps.user || {}).id !== (user || {}).id || (prevProps.user || {}).subscriptionLevelCode !== (user || {}).subscriptionLevelCode) {
        this.checkCode();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        user = _this$props4.user,
        defaultPromoCode = _this$props4.defaultPromoCode,
        onValidatedPromoCode = _this$props4.onValidatedPromoCode,
        onCodeRemoved = _this$props4.onCodeRemoved,
        darkMode = _this$props4.darkMode;
      var _this$state = this.state,
        status = _this$state.status,
        activationMessage = _this$state.activationMessage,
        invalidCodeMessage = _this$state.invalidCodeMessage;
      var promoCodeAlreadyEntered = Boolean(defaultPromoCode && !invalidCodeMessage || ['validated', 'locked'].includes(status));
      var disabled = ['validating', 'validated', 'locked'].includes(status) || !onValidatedPromoCode || promoCodeAlreadyEntered; // || !!invalidCodeMessage;

      // log.trace(
      //     'promoCodeAlreadyEntered',
      //     ['validated', 'locked'].includes(status) || promoCodeAlreadyEntered,
      //     invalidCodeMessage,
      //     activationMessage,
      //     status,
      //     defaultPromoCode,
      //     !onCodeRemoved && (['validated', 'locked'].includes(status) || promoCodeAlreadyEntered),
      // );

      return /*#__PURE__*/React.createElement(Form, {
        size: promoCodeAlreadyEntered ? 'large' : 'big',
        style: {
          textAlign: 'center',
          width: '450px',
          margin: 'auto'
        }
      }, /*#__PURE__*/React.createElement(Form.Field, {
        inline: true
      }, /*#__PURE__*/React.createElement("label", {
        style: {
          marginRight: '5px',
          color: darkMode ? '#d7e4e5' : '#7d6b6b'
        }
      }, "Promo Code"), /*#__PURE__*/React.createElement(Input, {
        name: "verificationCode",
        id: "verificationCode",
        defaultValue: defaultPromoCode || '',
        spellCheck: "false",
        "data-lpignore": true,
        placeholder: "Enter promo code",
        readOnly: disabled,
        style: {
          marginBottom: '.5em',
          marginTop: '.5em'
        }
      }), (!promoCodeAlreadyEntered || onCodeRemoved) && /*#__PURE__*/React.createElement(AwesomeButtonProgress, {
        size: "large",
        style: {
          width: '130px',
          marginBottom: '0.5em',
          marginTop: '.5em'
        },
        type: "secondary",
        loadingLabel: "Processing...",
        resultLabel: status === 'locked' || promoCodeAlreadyEntered ? 'Code Accepted' : status === 'invalid' ? 'Invalid Code' : 'Complete',
        releaseDelay: 2000,
        fakePress: !onCodeRemoved && (['validated', 'locked'].includes(status) || promoCodeAlreadyEntered),
        onPress: this.handleSubmit
      }, !promoCodeAlreadyEntered ? 'Apply Code' : 'Remove Code')), !!activationMessage && promoCodeAlreadyEntered && /*#__PURE__*/React.createElement(Message, {
        size: "tiny",
        info: true,
        style: {
          whiteSpace: 'pre-wrap'
        }
      }, "".concat(activationMessage).concat(onCodeRemoved && (user || {}).subscriptionLevelCode === 'FREE' && localStorage.getItem('promo-code-has-commission') !== 'false' ? FREE_PLAN_NOTE : '')), /*#__PURE__*/React.createElement(Transition, {
        visible: !!invalidCodeMessage,
        animation: "slide down",
        duration: 500,
        unmountOnHide: true
      }, /*#__PURE__*/React.createElement(Message, {
        style: {
          display: 'unset',
          whiteSpace: 'pre-wrap'
        },
        size: "tiny",
        warning: true
      }, invalidCodeMessage)));
    }
  }]);
  return PromotionCode;
}(React.Component);
export default PromotionCode;